enum ExploreSortOrder {
  AuctionEndEarliest = "AuctionEndEarliest",
  AuctionEndLatest = "AuctionEndLatest",
  FewestPieces = "FewestPieces",
  HighestPrice = "HighestPrice",
  LeastRecentlyAddedTo = "LeastRecentlyAddedTo",
  LowestPrice = "LowestPrice",
  MostPieces = "MostPieces",
  MostRecentlyAddedTo = "MostRecentlyAddedTo",
  MostRecentlySold = "MostRecentlySold",
  NameAscending = "NameAscending",
  NameDescending = "NameDescending",
  Newest = "Newest",
  Oldest = "Oldest",
  RarityHighest = "RarityHighest",
  RarityLowest = "RarityLowest",
}

export default ExploreSortOrder;
